<template>
  <section class="section">
    <div class="container">
      <div class="dashboard">
        <div class="head">
        <h1 class="title">riot.fm dashboard</h1>
        </div>
        <b-tabs size="is-medium">
          <b-tab-item label="Shows">
            <Shows></Shows>
          </b-tab-item>
          <b-tab-item label="Bands">
            <Bands></Bands>
          </b-tab-item>
          <b-tab-item label="Venues">
            <Venues></Venues>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import Shows from "./Shows";
import Bands from "./Bands";
import Venues from "./Venues";

export default {
  name: "Dashboard",
  components: { Bands, Shows, Venues },
  data() {
    return {
      file: null,
      filename: "",
      availableBands: [],
      venues: [],
      venue: [],

      isNewVenueDialog: false,
      event: {},
      bands: []
    };
  },
  watch: {
    file: function() {
      this.filename =
        Math.random()
          .toString(36)
          .substring(7) +
        "-" +
        this.file.name;
      this.event.flyer = this.filename;
    }
  },
  methods: {},
  mounted() {
    this.$store
      .dispatch("refresh")
      .then()
      .catch(() => this.$router.push("/api/login"));
    this.$store.dispatch("getEvents");
    this.$store.dispatch("getVenues");
    this.$store.dispatch("getBands");
  }
};
</script>

<style>
.addEvent {
  color: #000;
}

.addButton {
  margin-top: 16px;
}

h1 {
  font-size: x-large;
  color: black;
  margin-bottom: 16px;
}

.dashboard{
  background: white;
}

.head{
  text-align: center;
  padding-top: 24px;
  padding-bottom:  16px;
}

</style>
